var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "DocEditor" },
    [
      _c("DocEditorTabBar", {
        on: { activeWrite: _vm.activeWrite, activePreview: _vm.activePreview }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "DocEditor_InputContainer" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isActiveWrite,
                  expression: "isActiveWrite"
                }
              ],
              staticClass: "DocEditor_Toolbar"
            },
            [
              _c("ul", { staticClass: "DocEditor_ToolbarList" }, [
                _c("li", { staticClass: "DocEditor_ToolbarListItem" }, [
                  _c(
                    "button",
                    {
                      staticClass: "DocEditor_ToolbarIconButton",
                      on: { click: _vm.onOpenTreeDialog }
                    },
                    [
                      _c("FontAwesomeIcon", {
                        attrs: { icon: "link", size: "1x" }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isActiveWrite,
                  expression: "isActiveWrite"
                }
              ],
              staticClass: "DocEditor_Markdown"
            },
            [
              _c("textarea", {
                ref: "textarea",
                staticClass: "DocEditor_MarkdownTextArea",
                domProps: { value: _vm.markdown }
              })
            ]
          ),
          _vm._v(" "),
          _c("DocEditorPreview", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isActiveWrite,
                expression: "!isActiveWrite"
              }
            ],
            staticClass: "DocEditor_Preview",
            attrs: { previewedHtml: _vm.previewedHtml }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "DocEditor_ActionBar" },
        [
          _c("ActionButton", { attrs: { sub: true } }, [
            _c(
              "span",
              {
                on: {
                  click: function($event) {
                    _vm.cancelEditMarkdown()
                  }
                }
              },
              [_vm._v("Cancel")]
            )
          ]),
          _vm._v(" "),
          _c("ActionButton", [
            _c(
              "span",
              {
                on: {
                  click: function($event) {
                    _vm.onWriteMarkdown()
                  }
                }
              },
              [_vm._v("Save")]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Portal",
        { attrs: { to: "uploadDocumentImageDialog" } },
        [
          _c(
            "OverlayScreen",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowImageUploadDialog,
                  expression: "isShowImageUploadDialog"
                }
              ],
              on: { close: _vm.closeImageUploadDialog }
            },
            [
              _c("UploadImagePathDialog", {
                attrs: {
                  isAvailableWidth: true,
                  isAvailableSerial: true,
                  defaultImageFileName: _vm.defaultImageFileName
                },
                on: {
                  apply: _vm.uploadImage,
                  close: _vm.closeImageUploadDialog
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }